import Immutable from 'seamless-immutable'
import {FUNDING_FEE, INSURANCE_FUND} from 'actions'

const fundingHistory = (
  state = Immutable({
    fundingFeeList: [],
    insuranceFundList: []
  }),
  {type, response}
) => {
  switch (type) {
  case FUNDING_FEE:
    if (response.length > 0) {
      return state.set('fundingFeeList', response)
    }
    return state
  case INSURANCE_FUND:
    if (response.length > 0) {
      return state.set('insuranceFundList', response)
    }
    return state
  default:
    return state
  }
}

export default fundingHistory
